<template>
  <div class="is-flex">
    <div
      class="border-radius-4 py-1 px-2 mt-1 flex-shrink-0 is-align-self-flex-start"
      :class="classTagComputed"
    >
      <p class="label-11 averta-bold" :class="classTitleComputed">{{ renderTitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagStatus',
  props: {
    className: {
      type: String,
      default: ''
    },
    classTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    classTagComputed () {
      switch (this.title) {
        case 'started':
          return 'bg-light-blue-2 color-blue-1 averta-bold'
        case 'continued':
          return 'bg-purple-4 color-purple-5'
        case 'no-slot-yet':
          return 'bg-grey-2 color-dark-grey-6'
        case 'un-assigned':
          return 'bg-pink-10 color-red-4'
        case 'not-checked-in':
          return 'bg-orange-3 color-orange-4'
        case 'checked-in':
          return 'bg-light-green-3 color-green-5'

        default:
          return 'bg-grey-2'
      }
    },
    classTitleComputed () {
      return this.classTitle
    },
    renderTitle () {
      const statusTitles = {
        started: 'Baru Mulai',
        continued: 'Lanjutan',
        'no-slot-yet': 'Belum Ada Slot',
        'un-assigned': 'Belum Assign',
        'not-checked-in': 'Belum Absen',
        'checked-in': 'Sudah Absen'
      }

      return statusTitles[this.title]
    }
  }
}
</script>
